import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="py-20 bg-navy-900 text-white relative overflow-hidden" data-id="element-115">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-116">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-117"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-119">
          <span className="text-teal-400 font-medium tracking-wider uppercase text-sm mb-4 block" data-id="element-120">
            The Reality Check
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8" data-id="element-121">
            The truth nobody tells you
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-122">
            <p data-id="element-123">
              The problem isn't that you're not trying.{' '}
              <br className="hidden md:block" data-id="element-124" />
              <span className="text-white font-semibold" data-id="element-125">
                The problem is you're trying without a system.
              </span>
            </p>

            <div className="bg-white/10 p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-126">
              <p className="mb-4 font-medium text-white" data-id="element-127">
                NDIS punishes disorder.
              </p>
              <p className="text-base md:text-lg" data-id="element-128">
                It makes you repeat your story, chase answers, carry
                unstructured documents, and feel like everything depends on you
                — and always today.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}